import { Box, styled, StyleSystemProps } from '@withjoy/joykit';

export const StyledContainer = styled(Box)``;
export const StyledBillboardSafeContainer = styled(Box)``;

const containerStyles: StyleSystemProps = {
  width: '100%',
  height: [
    `calc(90vh - var(--mobile-public-shop-navbar-height, 0px) - var(--mobile-admin-shop-navbar-height, 0px))`,
    null,
    `calc(80vh - var(--mobile-public-shop-navbar-height, 0px) - var(--mobile-admin-shop-navbar-height, 0px))`,
    '56.25vw',
  ],
  zIndex: 'base',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  backgroundColor: 'rgb(0,0,0)',
  paddingBottom: 6,
  paddingTop: 600, //safe top space for small devices
};

const billboardSafeContainerStyles: StyleSystemProps = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
};

export const styles = {
  container: containerStyles,
  billboardSafeContainer: billboardSafeContainerStyles,
};
